module.exports = __webpack_public_path__ + "img/tss-2.ef4830a7.jpg";